/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AgreementTypeFromJSON, AgreementTypeToJSON, CarIdDtoFromJSON, CarIdDtoToJSON, CarModelIdDtoFromJSON, CarModelIdDtoToJSON, CustomerIdDtoFromJSON, CustomerIdDtoToJSON, } from './';
export function AgreementRequestFromJSON(json) {
    return AgreementRequestFromJSONTyped(json, false);
}
export function AgreementRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreementId': !exists(json, 'agreementId') ? undefined : json['agreementId'],
        'agreementNumber': !exists(json, 'agreementNumber') ? undefined : json['agreementNumber'],
        'customer': !exists(json, 'customer') ? undefined : CustomerIdDtoFromJSON(json['customer']),
        'begins': !exists(json, 'begins') ? undefined : (new Date(json['begins'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
        'type': !exists(json, 'type') ? undefined : AgreementTypeFromJSON(json['type']),
        'car': !exists(json, 'car') ? undefined : CarIdDtoFromJSON(json['car']),
        'carModels': !exists(json, 'carModels') ? undefined : (json['carModels'] === null ? null : json['carModels'].map(CarModelIdDtoFromJSON)),
    };
}
export function AgreementRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreementId': value.agreementId,
        'agreementNumber': value.agreementNumber,
        'customer': CustomerIdDtoToJSON(value.customer),
        'begins': value.begins === undefined ? undefined : (value.begins.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
        'type': AgreementTypeToJSON(value.type),
        'car': CarIdDtoToJSON(value.car),
        'carModels': value.carModels === undefined ? undefined : (value.carModels === null ? null : value.carModels.map(CarModelIdDtoToJSON)),
    };
}
